const basePlacements = [
    'top',
    'right',
    'bottom',
    'left'
];
function getRelatedPlacements(basePlacement) {
    return [
        basePlacement,
        `${basePlacement}-start`,
        `${basePlacement}-end`
    ];
}
function getOppositeAlignmentPlacement(placement) {
    const hash = {
        start: 'end',
        end: 'start'
    };
    return placement.replaceAll(/start|end/g, (matched)=>hash[matched]);
}
function getOppositePlacement(placement) {
    const hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replaceAll(/left|right|bottom|top/g, (matched)=>hash[matched]);
}
function getOppositeAxisPlacement(placement) {
    const hash = {
        left: [
            ...getRelatedPlacements('bottom'),
            ...getRelatedPlacements('top')
        ],
        right: [
            ...getRelatedPlacements('bottom'),
            ...getRelatedPlacements('top')
        ],
        bottom: [
            ...getRelatedPlacements('right'),
            ...getRelatedPlacements('left')
        ],
        top: [
            ...getRelatedPlacements('right'),
            ...getRelatedPlacements('left')
        ]
    };
    return hash[placement.split('-').shift()] ?? [
        placement
    ];
}
function getOrderedFallbackPlacements(placement, oppositeAxisPlacementsEnabled) {
    const oppositePlacement = getOppositePlacement(placement);
    const placements = [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
    if (oppositeAxisPlacementsEnabled) placements.push(...getOppositeAxisPlacement(placement));
    return placements;
}
export { basePlacements, getOrderedFallbackPlacements };
